import { render, staticRenderFns } from "./doctorStatisticsYJ.vue?vue&type=template&id=744e18e9&scoped=true"
import script from "./doctorStatisticsYJ.vue?vue&type=script&lang=js"
export * from "./doctorStatisticsYJ.vue?vue&type=script&lang=js"
import style0 from "./doctorStatisticsYJ.vue?vue&type=style&index=0&id=744e18e9&prod&scoped=true&lang=css"
import style1 from "./doctorStatisticsYJ.vue?vue&type=style&index=1&id=744e18e9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "744e18e9",
  null
  
)

export default component.exports